import { createContext, useContext, useState } from 'react';

// Create the theme context
const ThemeContext = createContext();

// Custom hook to use the theme context
const useTheme = () => useContext(ThemeContext);

// Theme provider component
const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light'); // Default theme is light

  // Function to toggle between light and dark themes
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // Return the provider with theme and toggle function
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Export the custom hook and provider
export { ThemeContext, ThemeProvider, useTheme };
